<template>
  <div>
    <genome-field-collection v-model="a_genomes"></genome-field-collection>
    <genotype-field-collection v-model="a_genotypes"></genotype-field-collection>
    <v-btn @click="submit">Submit</v-btn>
  </div>
</template>

<script>
import GenomeFieldCollection from '@/components/data/GenomeFieldCollection.vue';
import GenotypeFieldCollection from '@/components/data/GenotypeFieldCollection.vue';

export default {
  components: {
    GenomeFieldCollection,
    GenotypeFieldCollection,
  },
  data() {
    return {
      a_genomes: [],
      a_genotypes: [],
    };
  },
  methods: {
    submit() {
      console.log('submit :');
      console.log(this.a_genomes);
      console.log(this.a_genotypes);
    },
  },
};
</script>
